<template>
  <div class="right-chart-1">
    <div class="rc1-header">产量数据</div>

    <div class="rc1-chart-container">
      <div class="left1">
        <div class="number">{{ qty }}</div>
        <div>今日累计生产</div>
      </div>
      <div class="left1">
        <div class="number">{{ total }}</div>
        <div>今日计划时间</div>
      </div>
    </div>
    <div class="rc1-chart-container">
      <div class="left2">
        <div class="number">{{ planStop }}</div>
        <div>计划停机时间</div>
      </div>
      <div class="left2">
        <div class="number">{{ realTime }}</div>
        <div>实时工作时间</div>
      </div>
      <div class="left2">
        <div class="number">{{ qualifiedRatio * 100 }}%</div>
        <div>今日合格率</div>
      </div>
    </div>
  </div>
</template>




<script>
export default {
  name: 'RightChart1',
  props: {
    qty: Number,
    total: Number,
    planStop: Number,
    realTime: Number,
    qualifiedRatio: Number,
  },
  data() {
    return {
      config: {
        data: [
          {
            name: '今日累计生产',
            value: 25
          },
          {
            name: '今日计划时间',
            value: 66
          },
          {
            name: '计划停机时间',
            value: 123
          },
          {
            name: '实时工作时间',
            value: 72
          },
          {
            name: '今日合格率',
            value: 99
          }
        ],

      }
    }
  },
  watch: {
    'qty': function (newVal) {
      this.update(0, newVal);
    },
    'total': function (newVal) {
      this.update(1, newVal);
    }, 'planStop': function (newVal) {
      this.update(2, newVal);
    },
    'realTime': function (newVal) {
      this.update(3, newVal);
    },
    'qualifiedRatio': function (newVal) {
      this.update(4, newVal);
    }
  },
  methods: {
    update(index, value) {
      this.$data.config.data[index].value = value.toFixed(2);

      this.$data.config = { ...this.$data.config }
    }
  }
}
</script>

<style lang="less">
.right-chart-1 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .rc1-header {
    font-size: 24px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
  }

  .rc1-chart-container {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  .left1 {
    width: 50%;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .number {
      font-size: 38px;
      color: #096dd9;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }
  .left2 {
    width: 33%;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .number {
      font-size: 38px;
      color: #096dd9;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }

  .right {
    flex: 1;
    padding-bottom: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }
}
</style>
